<template>
  <v-radio-group :mandatory="!!modifier.minSelected" class="mt-0" hide-details v-model="selectedOption">
    <v-layout
      v-for="option in modifier.options" :key="option.id"
      @click="change(option.id)"
      class="ma-2 clickable"
      :set="amountAndCurrency = getAmountAndCurrency(option.id)"
      >
      <v-radio :value="option.id" :label="option.name" color="primary" :id="option.id" class="mb-0" />
      <v-layout v-if="amountAndCurrency" column align-end>
        <span class="primary--text">
          {{ getPriceString({ amountAndCurrency: amountAndCurrency }) }}
        </span>
        <span v-if="showDisplayCurrency" label class="grey--text">
          {{ getPriceString({ amountAndCurrency: amountAndCurrency, displayCurrency: displayCurrency }) }}
        </span>
      </v-layout>
    </v-layout>
  </v-radio-group>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    getAmountAndCurrency: { type: Function, required: true },
    modifier: { type: Object, required: true },
  },
  data: () => ({
    selectedOption: null,
  }),
  computed: {
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency']),
    ...mapState({
      selectedProduct: ({ cart }) => cart.selectedProduct,
      products: ({ cart }) => cart.products,
    }),
    stateProduct () {
      return this.selectedProduct
        ? this.products.find(stateProduct => stateProduct.product.id === this.selectedProduct.id)
        : null
    },
    selectedOptions () {
      return this.stateProduct ? this.stateProduct.selectedOptions : []
    },
  },
  methods: {
    change (optionId) {
      this.modifier.options
        .filter((o) => (o.id !== optionId))
        .forEach((o) => this.$store.commit('cart/removeSelectedOption', { optionId: o.id, productId: this.selectedProduct.id }))
      if (!this.selectedOptions.includes(optionId)) {
        this.selectedOption = optionId
        this.$store.commit('cart/toggleSelectedOption', { optionId, productId: this.selectedProduct.id })
      } else if (this.selectedOptions.includes(optionId) && !this.modifier.minSelected) {
        this.selectedOption = null
        this.$store.commit('cart/toggleSelectedOption', { optionId, productId: this.selectedProduct.id })
      }
    },
  },
  created () {
    if (this.modifier.minSelected) this.change(this.modifier.options[0].id)
  },
}
</script>
